import {Storage as Store} from '@capacitor/storage';
import {set} from "vue";

export const DEFAULT_STORE = 'default_store'
export const ALL_STORES = 'all_stores'

export const ADMIN = 'admin'
export const AllUsers = 'all_users'
export const CurrentUser = 'current_user'
export const AllSecurities = 'securities'

export const DEVICE_LOCATION = 'device_location'
export const DEVICE_ORDER_LOCATIONS = 'device_order_locations'

const notEmpty = (val) => {
    if (!val) return false
    return val !== ''
}
const encryptAdmin = (val) => {
    return window.btoa(val);
}
const decryptAdmin = (val) => {
    if (!val) return undefined;
    if (val.toString().charAt(0) === `"`) {
        val = val.toString().slice(1, -1);
    }
    return JSON.parse(window.atob(val))
}

const getValue = async (key) => {
    const value = await Store.get({
        key: key
    })
    return JSON.parse(value.value);
}

const setValue = async (key , value) => {
    await Store.set({
        key: key,
        value: JSON.stringify(value)
    });
}

export const Storage = {
    setAdminUser: async (user) => {
        await Store.set({
            key: ADMIN, value: encryptAdmin(JSON.stringify(user))
        })
    },
    getAdminUser: async () => {
        const value = await Store.get({
            key: ADMIN
        })
        return decryptAdmin(value.value)
    },

    setAllStores: async (payload) => {
        await setValue(ALL_STORES,payload)
    },

    getAllStores: async () => {
        return getValue(ALL_STORES)
    },
    setDefaultStore: async (defaultStore) => {
        await setValue(DEFAULT_STORE , defaultStore);
    },
    getDefaultStore: async () => {
        return getValue(DEFAULT_STORE)
    },

    getCurrentStoreDB: async () => {
        let store = await getValue(DEFAULT_STORE)
        if (!store) return null;
        return store.StoreDB;
    },
    setAllUsers: async (users) => {
        await setValue(AllUsers , users)
    },
    getAllUsers: async () => {
       return getValue(AllUsers);
    },
    setAllSecurities: async (users) => {
        await setValue(AllSecurities , users)
    },
    getAllSecurities: async () => {
        return getValue(AllSecurities);
    },

    setCurrentUser: async (currentUser) => {
        await setValue(CurrentUser , currentUser)
    },
    getCurrentUser: async () => {
        return getValue(CurrentUser)
    },
    setDeviceOrderLocation: async (payload) => {
        await setValue(DEVICE_LOCATION, payload)
    },
    getDeviceOrderLocation: async () => {
        return getValue(DEVICE_LOCATION)
    },
    setAllDeviceOrderLocation: async (payload) => {
        await setValue(DEVICE_ORDER_LOCATIONS, payload)
    },
    getAllDeviceOrderLocation: async () => {
        return getValue(DEVICE_ORDER_LOCATIONS)
    },
    getDeviceLocationID: async () => {
        let deviceLocation = await getValue(DEVICE_LOCATION);
        if (!deviceLocation) return null;
        return deviceLocation.id;
    },
    clear: async () => Store.clear(),
}
